module.exports = __webpack_public_path__ + "static/img/nodata.e67357a4.png";